import cx from 'classnames';
import Link from 'next/link';
import Trans from 'next-translate/Trans';
import useTranslation from 'next-translate/useTranslation';
import { memo, useMemo } from 'react';

import useLinkProps from '../../../../hooks/use-link-props';
import useLoggedUser from '../../../../hooks/use-logged-user';
import getCategoryNames from '../../../../utils/get-category-names';
import FeatureLink from '../../../ui/links/featured';
import OrSeparator from '../../../ui/separator/or-separator';
import { useOpenSearch } from '../../search/state';

const NoStock = ({
  vehicle,
  selection,
  groups,
  createAlert = true,
}: {
  vehicle?: any;
  selection?: any;
  groups?: TCategories;
  createAlert?: boolean;
}) => {
  const { t } = useTranslation();
  const getLink = useLinkProps();
  const user = useLoggedUser();
  const openSearch = useOpenSearch();

  const info = useMemo(
    () =>
      selection?.category
        ? getCategoryNames(selection.category, groups)
        : selection,
    [selection, groups]
  );

  const carCompleteName = useMemo(
    () =>
      vehicle
        ? `${vehicle.brand.name} ${vehicle.model ? vehicle.model.name : ''} ${
            vehicle.version ? vehicle.version.name : ''
          }`
        : null,
    [vehicle]
  );

  return (
    <div className="container mx-auto max-lg:text-center">
      <p>
        {carCompleteName ? (
          <Trans
            i18nKey="products:no-result.part-car"
            components={{ span: <span className={cx('font-bold')} /> }}
            values={{
              part: info?.subCategory || selection || '',
              car: carCompleteName,
            }}
          />
        ) : (
          <Trans
            i18nKey="products:no-result.part"
            components={{ span: <span className={cx('font-bold')} /> }}
            values={{
              part: info?.subCategory || selection,
            }}
          />
        )}
      </p>
      {createAlert && (
        <div className={cx('py-5', 'text-center')}>
          <Link
            {...getLink(
              user ? 'private-area-part-alerts-create' : 'create-part-alert'
            )}
            passHref
            legacyBehavior
          >
            <FeatureLink className={cx('inline-block', 'mb-4')}>
              {t('products:create-alert')}
            </FeatureLink>
          </Link>
          <OrSeparator />
          {/* button to open global search == header search */}
          <FeatureLink
            className={cx('inline-block', 'mt-2')}
            onClick={openSearch}
          >
            {t('products:new-search')}
          </FeatureLink>
        </div>
      )}
    </div>
  );
};

export default NoStock;
